import React, { useEffect } from "react";

function DICOMViewer() {
  useEffect(() => {
    // Check for Cross-Origin Isolation status on component mount
    if (window.crossOriginIsolated) {
      console.log("Cross-Origin Isolation is active.");
    } else {
      console.warn("Cross-Origin Isolation is not active.");
    }
  }, []); // Empty dependency array ensures this effect runs only once, on mount

  return (
    <section>
      <div className="table-responsive">
        <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
          <i className="fa-solid fa-comment" aria-hidden="true" style={{ color: 'red' }}></i> DICOM Viewer
        </h3>
        <iframe

          src={'http://localhost:8080'}
          style={{ width: '100%', height: '150vh', border: 'none' }}
          title="PACS Viewer"
          allow="camera; microphone; geolocation"
        />
      </div>
    </section>
  );
}

export default DICOMViewer;
